export var createMuiTabsOverrides = function (_a) {
    var tokens = _a.tokens;
    return {
        defaultProps: {
            indicatorColor: 'primary',
            textColor: 'primary',
        },
        styleOverrides: {
            indicator: {
                backgroundColor: tokens.color_border_selected,
            },
            flexContainer: {
                display: 'block',
            },
            scroller: {
                borderBottom: "1px solid ".concat(tokens.color_border_default),
            },
        },
    };
};
